<template>
  <div class="info">
     <div class="last-message">
      <p>Connection Status:</p>
      <p style="font-weight:700" :style="{color: connection ? 'green' : 'red' }">{{ connection ? 'CONNECTED' : 'DISCONNECTED' }}</p>
    </div>
    <div class="last-message">
      <p>Last Message received:</p>
      <p>{{ lastInfoReceived }}</p>
    </div>
    <div class="last-message">
      <p>Received:</p>
      <p>{{ timeBetween }}</p>
      <p>ago.</p>
    </div>
    <div class="last-message">
      <p>Last reconnected:</p>
      <p>{{ lastReconnect }}</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    lastInfoReceived() {
      /* eslint-disable */
      let x = this.now;
      return new Date(this.$diamond.lastMessageStamp).toLocaleString();
    },


    timeBetween() {
      return this.toHMS(this.now - this.$diamond.lastMessageStamp);
    },

    connection(){
      let x = this.now;
      return this.$diamond.isConnected
    },

    lastReconnect(){
      /* eslint-disable */
      let x = this.now;
      return new Date(this.$diamond.lastReconnect).toLocaleString()
    }
  },
};
</script>

<style scoped>
.info {
  width: 400px;
}

.last-message {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>